const api = {
  // Login: '/auth/login',
  Login: `/auth/login`,
  Logout: `/auth/logout`,
  ForgePassword: `/auth/forge-password`,
  Register: `/auth/register`,
  twoStepCode: `/auth/2step-code`,
  SendSms: `/account/sms`,
  SendSmsErr: `/account/sms_err`,
  // get my info
  UserInfo: `/user/info`
}
export default api
